import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Cards from '../Cards';
import Footer from '../Footer';
import Seal from '../Seal';
import AudioStreaming from '../AudioStreaming';
import FM1_image from '../station_logos/station-fm1.png'
import FM2_image from '../station_logos/station-fm2.png'
import RP1_image from '../station_logos/rplogo-news-manila.png'
import RP2_image from '../station_logos/rp2.png'
import RP3_image from '../station_logos/rp3.png'
import RP4_image from '../station_logos/rp4.png'

function Home () {
    const audioUrls = [
        {
        title: 'RP1',
        name: 'Radyo Pilipinas 1',
        url: 'http://58.97.187.52:5001/rp1',
        image: RP1_image,
        desc: "As the goverments flagship radio station, it serves as a medium of development communication, a conduit between the goverment and the people, aiming to mobilize all sectors of society towards development and nationalism; the station features live, up-to-the-minute goverment news, live coverage of press conferences, as well as relevant information from different goverment sectors."
        },
        {
        title: 'RP2',
        name: 'Radyo Pilipinas 2',
        url:'http://58.97.187.52:5002/rp2',
        image: RP2_image,
        desc: "Radyo Pilipinas Dos- is the countrys first radio station dedicated to sports and  mandated   to promote “Sports for All”.   RP 2s programming   focuses on the governments mandate   to promote Sports among the  youth and  produces    radio programs  showcasing  the   national athletes  participation in different  international  tournaments, including the SEA Games, Asian Games and the Olympics, serving as inspiration to young sports-minded Filipinos.      RP 2 Sports, being heard over  918 KHZ/AM, also   airs  major  sports news, here and abroad, and serves as broadcast coveror  of  the countrys campaigns in different international competitions."

        },
        {
            title: 'RP3',
            name: 'Radyo Pilipinas 3',
            url:'http://58.97.187.52:8000/rp3',
            image: RP3_image,
            desc:  "Radyo Pilipinas 3 (RP3) Alert is the designated radio station of the Bureau of Broadcast Services on emergency-related and disaster response programs covering land, air, and sea which highlights emergency preparedness, training on-air, and public service announcements. As a general information station, RP3 Alert also promotes the culture and the arts, advanced educational goals, developments in science and technology, pursuit in health care and nutrition, environmental campaigns, drive in support of local tourism, and advocacy for the welfare of the youth and women. RP3 Alert produced segmented programs including institutional plugs and selected musical genres."



        },

        {
            title: 'RP4',
            name: 'Radyo Pilipinas World Service',
            url: ' http://58.97.187.52:5007/rp4',
            image:  RP4_image,
            desc: `The Overseas Broadcast of the Presidential Broadcast Service (PBS) with Office address at 4/Flr PIA Bldg Visayas Avenue Quezon City zip code 1100. Radyo Pilipinas is being broadcast all over the world thru the facilities of the International Broadcasting Bureau - Voice of America. The programs being aired over DZRP are produced by the men and women of PBS dedicated in serving the needs of Overseas Filipino Workers and Filipinos all over the globe.`
            },

        {
        title: 'FM1',
        name: 'Republika FM 1',
        url:'http://58.97.187.52:5006/fm1',
        image: FM1_image,
        desc: " DWFO 87.5-Republika FM1 Manila - It is our love for the youth that made this station come to life. We want to reach out to them and nurture them. We would like to bring them closer to us by speaking their language and draw them closer together by playing the kind of music that matters to their generation. We want to bond with them so we can communicate with them. This station is a platform created to spread optimism and promote love of God and country; a channel for us to educate, inform, and form the youth to be the kind of people this country needs."
        },
        {
        title: 'FM2',
        name: 'Capital FM 2',
        url:' http://58.97.187.52:5007/fm2',
        image: FM2_image,
        desc: "DWFT 104.3-Capital FM2 DWFT- Capital FM2 airs well curated playlists ranging from popular hits of the 70s, 80s, 90s, 2000s, showcasing adult contemporary, light and easy listening favorites, ballads, and homegrown music of the present day. It aims to reach out to the mature audience - its primary market 30 to 54 years of age and its secondary market 55 to 64 years old from the A, B, and upper C spectra. FM2 unites Gen X’ers by revolutionizing old school radio and offers a reprieve from the fast pace of everyday life by serving mind-altering tunes with less mind-numbing talk. DWFT fosters love of country and the Filipino people by speaking to them in a language they can relate to – the music of their generation.  "
        },






        // Add more URLs as needed
      ];

    return (
    <>
     <HeroSection/>
     <AudioStreaming streams={audioUrls}/>
     <Cards/>
     <Seal/>



    </>
    );
}


export default Home;